module.exports = __webpack_public_path__ + "static/img/4Banner Logo_Desktop_512 x 768.00c158cd.png";